/**
 * This file is a fork of the OCR module of the Alt1 libraries by Skillbert.
 * Licensing from LICENSE.md does not apply to this.
 * */
import { ImageData, Rect } from "alt1";
import { util } from "../util/util";
import { FakeLodash } from "../coreutil/FakeLodash";
export var OCR;
(function (OCR) {
    var scoreAll = util.scoreAll;
    var rgbSimilarity = util.rgbSimilarity;
    OCR.debugout = {};
    /**
     * draws the font definition to a buffer and displays it in the dom for debugging purposes
     * @param font
     */
    function debugFont(font) {
        var spacing = font.width + 2;
        var buf = new ImageData(spacing * font.chars.length, font.height + 1);
        for (var a = 0; a < buf.data.length; a += 4) {
            buf.data[a] = buf.data[a + 1] = buf.data[a + 2] = 0;
            buf.data[a + 3] = 255;
        }
        for (var a = 0; a < font.chars.length; a++) {
            var bx = a * spacing;
            var chr = font.chars[a];
            for (var b = 0; b < chr.pixels.length; b += (font.shadow ? 4 : 3)) {
                buf.setPixel(bx + chr.pixels[b], chr.pixels[b + 1], [chr.pixels[b + 2], chr.pixels[b + 2], chr.pixels[b + 2], 255]);
                if (font.shadow) {
                    buf.setPixel(bx + chr.pixels[b], chr.pixels[b + 1], [chr.pixels[b + 3], 0, 0, 255]);
                }
            }
        }
        buf.show();
    }
    OCR.debugFont = debugFont;
    function unblendBlackBackground(img, r, g, b) {
        var rimg = new ImageData(img.width, img.height);
        for (var i = 0; i < img.data.length; i += 4) {
            var col = decomposeblack(img.data[i], img.data[i + 1], img.data[i + 2], r, g, b);
            rimg.data[i + 0] = col[0] * 255;
            rimg.data[i + 1] = rimg.data[i + 0];
            rimg.data[i + 2] = rimg.data[i + 0];
            rimg.data[i + 3] = 255;
        }
        return rimg;
    }
    OCR.unblendBlackBackground = unblendBlackBackground;
    /**
     * unblends a imagebuffer into match strength with given color
     * the bgimg argument should contain a second image with pixel occluded by the font visible.
     * @param img
     * @param shadow detect black as second color
     * @param bgimg optional second image to
     */
    function unblendKnownBg(img, bgimg, shadow, r, g, b) {
        if (bgimg && (img.width != bgimg.width || img.height != bgimg.height)) {
            throw "bgimg size doesn't match";
        }
        var rimg = new ImageData(img.width, img.height);
        var totalerror = 0;
        for (var i = 0; i < img.data.length; i += 4) {
            var col = decompose2col(img.data[i], img.data[i + 1], img.data[i + 2], r, g, b, bgimg.data[i + 0], bgimg.data[i + 1], bgimg.data[i + 2]);
            if (shadow) {
                if (col[2] > 0.01) {
                    console.log("high error component: " + (col[2] * 100).toFixed(1) + "%");
                }
                totalerror += col[2];
                var m = 1 - col[1] - Math.abs(col[2]); //main color+black=100%-bg-error
                rimg.data[i + 0] = m * 255;
                rimg.data[i + 1] = col[0] / m * 255;
                rimg.data[i + 2] = rimg.data[i + 0];
            }
            else {
                rimg.data[i + 0] = col[0] * 255;
                rimg.data[i + 1] = rimg.data[i + 0];
                rimg.data[i + 2] = rimg.data[i + 0];
            }
            rimg.data[i + 3] = 255;
        }
        return rimg;
    }
    OCR.unblendKnownBg = unblendKnownBg;
    /**
     * Unblends a font image that is already conpletely isolated to the raw image used ingame. This is the easiest mode for pixel fonts where alpha is 0 or 255, or for extracted font files.
     * @param img
     * @param r
     * @param g
     * @param b
     * @param shadow whether the font has a black shadow
     */
    function unblendTrans(img, shadow, r, g, b) {
        var rimg = new ImageData(img.width, img.height);
        var pxlum = r + g + b;
        for (var i = 0; i < img.data.length; i += 4) {
            if (shadow) {
                var lum = img.data[i + 0] + img.data[i + 1] + img.data[i + 2];
                rimg.data[i + 0] = img.data[i + 3];
                rimg.data[i + 1] = lum / pxlum * 255;
                rimg.data[i + 2] = rimg.data[i + 0];
            }
            else {
                rimg.data[i + 0] = img.data[i + 3];
                rimg.data[i + 1] = rimg.data[i + 0];
                rimg.data[i + 2] = rimg.data[i + 0];
            }
            rimg.data[i + 3] = 255;
        }
        return rimg;
    }
    OCR.unblendTrans = unblendTrans;
    /**
     * Determised wether color [rgb]m can be a result of a blend with color [rgb]1 that is p (0-1) of the mix
     * It returns the number that the second color has to lie outside of the possible color ranges
     * @param rm resulting color
     * @param r1 first color of the mix (the other color is unknown)
     * @param p the portion of the [rgb]1 in the mix (0-1)
     */
    function canblend(rm, gm, bm, r1, g1, b1, p) {
        const m = Math.min(50, p / (1 - p));
        const r = rm + (rm - r1) * m;
        const g = gm + (gm - g1) * m;
        const b = bm + (bm - b1) * m;
        return Math.max(0, -r, -g, -b, r - 255, g - 255, b - 255);
    }
    OCR.canblend = canblend;
    /**
     * decomposes a color in 2 given component colors and returns the amount of each color present
     * also return a third (noise) component which is the the amount leftover orthagonal from the 2 given colors
     */
    function decompose2col(rp, gp, bp, r1, g1, b1, r2, g2, b2) {
        //get the normal of the error (cross-product of both colors)
        var r3 = g1 * b2 - g2 * b1;
        var g3 = b1 * r2 - b2 * r1;
        var b3 = r1 * g2 - r2 * g1;
        //normalize to length 255
        var norm = 255 / Math.sqrt(r3 * r3 + g3 * g3 + b3 * b3);
        r3 *= norm;
        g3 *= norm;
        b3 *= norm;
        return decompose3col(rp, gp, bp, r1, g1, b1, r2, g2, b2, r3, g3, b3);
    }
    OCR.decompose2col = decompose2col;
    /**
     * decomposes a pixel in a given color component and black and returns what proportion of the second color it contains
     * this is not as formal as decompose 2/3 and only give a "good enough" number
     */
    function decomposeblack(rp, gp, bp, r1, g1, b1) {
        var dr = Math.abs(rp - r1);
        var dg = Math.abs(gp - g1);
        var db = Math.abs(bp - b1);
        var maxdif = Math.max(dr, dg, db);
        return [1 - maxdif / 255];
    }
    OCR.decomposeblack = decomposeblack;
    /**
     * decomposes a color in 3 given component colors and returns the amount of each color present
     */
    function decompose3col(rp, gp, bp, r1, g1, b1, r2, g2, b2, r3, g3, b3) {
        //P=x*C1+y*C2+z*C3
        //assemble as matrix
        //M*w=p
        //get inverse of M
        //dirty written out version of cramer's rule
        var A = g2 * b3 - b2 * g3;
        var B = g3 * b1 - b3 * g1;
        var C = g1 * b2 - b1 * g2;
        var D = b2 * r3 - r2 * b3;
        var E = b3 * r1 - r3 * b1;
        var F = b1 * r2 - r1 * b2;
        var G = r2 * g3 - g2 * r3;
        var H = r3 * g1 - g3 * r1;
        var I = r1 * g2 - g1 * r2;
        var det = r1 * A + g1 * D + b1 * G;
        //M^-1*p=w
        var x = (A * rp + D * gp + G * bp) / det;
        var y = (B * rp + E * gp + H * bp) / det;
        var z = (C * rp + F * gp + I * bp) / det;
        return [x, y, z];
    }
    OCR.decompose3col = decompose3col;
    /**
     * brute force to the exact position of the text
     */
    function findChar(buffer, font, col, x, y, w, h) {
        if (x < 0) {
            return null;
        }
        if (y - font.basey < 0) {
            return null;
        }
        if (x + w + font.width > buffer.width) {
            return null;
        }
        if (y + h - font.basey + font.height > buffer.height) {
            return null;
        }
        var best = 1000; //TODO finetune score constants
        var bestchar = null;
        for (var cx = x; cx < x + w; cx++) {
            for (var cy = y; cy < y + h; cy++) {
                var chr = readChar(buffer, font, col, cx, cy, false, false);
                if (chr != null && chr.sizescore < best) {
                    best = chr.sizescore;
                    bestchar = chr;
                }
            }
        }
        return bestchar;
    }
    OCR.findChar = findChar;
    /**
     * reads text with unknown exact coord or color. The given coord should be inside the text
     * color selection not implemented yet
     */
    function findReadLine(buffer, font, cols, x, y, w = -1, h = -1) {
        if (w == -1) {
            w = font.width + font.spacewidth;
            x -= Math.ceil(w / 2);
        }
        if (h == -1) {
            h = 7;
            y -= 1;
        }
        var chr = null;
        if (cols.length > 1) {
            //TODO use getChatColor() instead for non-mono?
            var sorted = getChatColorMono(buffer, new Rect(x, y - font.basey, w, h), cols);
            //loop until we have a match (max 2 cols)
            for (var a = 0; a < 2 && a < sorted.length && chr == null; a++) {
                chr = findChar(buffer, font, sorted[a].col, x, y, w, h);
            }
        }
        else {
            chr = findChar(buffer, font, cols[0], x, y, w, h);
        }
        if (chr == null) {
            return { debugArea: { x, y, w, h }, text: "", fragments: [] };
        }
        return readLine(buffer, font, cols, chr.x, chr.y, true, true);
    }
    OCR.findReadLine = findReadLine;
    function getChatColorMono(buf, rect, colors) {
        var colormap = colors.map(c => ({ col: c, score: 0 }));
        if (rect.x < 0 || rect.y < 0 || rect.x + rect.width > buf.width || rect.y + rect.height > buf.height) {
            return colormap;
        }
        var data = buf.data;
        var maxd = 50;
        for (var colobj of colormap) {
            var score = 0;
            var col = colobj.col;
            for (var y = rect.y; y < rect.y + rect.height; y++) {
                for (var x = rect.x; x < rect.x + rect.width; x++) {
                    var i = x * 4 + y * 4 * buf.width;
                    var d = Math.abs(data[i] - col[0]) + Math.abs(data[i + 1] - col[1]) + Math.abs(data[i + 2] - col[2]);
                    if (d < maxd) {
                        score += maxd - d;
                    }
                }
            }
            colobj.score = score;
        }
        return colormap.sort((a, b) => b.score - a.score);
    }
    OCR.getChatColorMono = getChatColorMono;
    function unblend(r, g, b, R, G, B) {
        var m = Math.sqrt(r * r + g * g + b * b);
        var n = Math.sqrt(R * R + G * G + B * B);
        var x = (r * R + g * G + b * B) / n;
        var y = Math.sqrt(Math.max(0, m * m - x * x));
        var r1 = Math.max(0, (63.75 - y) * 4);
        var r2 = x / n * 255;
        if (r2 > 255) //brighter than refcol
         {
            r1 = Math.max(0, r1 - r2 + 255);
            r2 = 255;
        }
        return [r1, r2];
    }
    function getChatColor(buf, rect, colors) {
        const scored_colors = scoreAll(colors, col => {
            let score = 0;
            for (let y = rect.y; y < rect.y + rect.height; y++) {
                if (y < 0 || y + 1 >= buf.height)
                    continue;
                for (let x = rect.x; x < rect.x + rect.width; x++) {
                    if (x < 0 || x + 1 >= buf.width)
                        continue;
                    const similarity = rgbSimilarity(buf.getPixel(x, y), col);
                    if (similarity > 0.9)
                        score += similarity;
                }
            }
            return score;
        });
        return FakeLodash.maxBy(scored_colors, c => c.score).value;
        /*
            for (let col of colors) {
              let score = 0;
    
              for (let y = rect.y; y < rect.y + rect.height; y++) {
                for (let x = rect.x; x < rect.x + rect.width; x++) {
                  if (x < 0 || x + 1 >= buf.width) { continue; }
                  if (y < 0 || y + 1 >= buf.width) { continue; }
                  let i1 = buf.pixelOffset(x, y);
                  let i2 = buf.pixelOffset(x + 1, y + 1);
                  var pixel1 = unblend(data[i1 + 0], data[i1 + 1], data[i1 + 2], col[0], col[1], col[2]);
                  var pixel2 = unblend(data[i2 + 0], data[i2 + 1], data[i2 + 2], col[0], col[1], col[2]);
                  //TODO this is from c# can simplify a bit
                  var s = (pixel1[0] / 255 * pixel1[1] / 255) * (pixel2[0] / 255 * (255.0 - pixel2[1]) / 255);
                  score += s;
                }
              }
              if (score > bestscore) {
                bestscore = score;
                best = col;
              }
            }
            //bestscore /= rect.width * rect.height;
            return best;*/
    }
    OCR.getChatColor = getChatColor;
    /**
     * reads a line of text with exactly known position and color. y should be the y coord of the text base line, x should be the first pixel of a new character
     */
    function readLine(buffer, font, colors, x, y, forward, backward = false) {
        if (typeof colors[0] != "number" && colors.length == 1) {
            colors = colors[0];
        }
        var multicol = typeof colors[0] != "number";
        var allcolors = multicol ? colors : [colors];
        var detectcolor = function (sx, sy, backward) {
            const w = font.width;
            if (backward) {
                sx -= w;
            }
            sy -= font.basey;
            return getChatColor(buffer, { x: sx, y: sy, width: w, height: font.height }, allcolors);
        };
        var fragments = [];
        var x1 = x;
        var x2 = x;
        var maxspaces = (typeof font.maxspaces == "number" ? font.maxspaces : 1);
        let fragtext = "";
        let fraghadprimary = false;
        var lastcol = null;
        let addfrag = (forward) => {
            if (!fragtext) {
                return;
            }
            let frag = {
                text: fragtext,
                color: lastcol,
                index: 0,
                xstart: x + (forward ? fragstartdx : fragenddx),
                xend: x + (forward ? fragenddx : fragstartdx)
            };
            if (forward) {
                fragments.push(frag);
            }
            else {
                fragments.unshift(frag);
            }
            fragtext = "";
            fragstartdx = dx;
            fraghadprimary = false;
        };
        for (var dirforward of [true, false]) {
            //init vars
            if (dirforward && !forward) {
                continue;
            }
            if (!dirforward && !backward) {
                continue;
            }
            var dx = 0;
            var fragstartdx = dx;
            var fragenddx = dx;
            var triedspaces = 0;
            var triedrecol = false;
            var col = multicol ? null : colors;
            while (true) {
                col = col || detectcolor(x + dx, y, !dirforward);
                var chr = (col ? readChar(buffer, font, col, x + dx, y, !dirforward, true) : null);
                if (col == null || chr == null) {
                    if (triedspaces < maxspaces) {
                        dx += (dirforward ? 1 : -1) * font.spacewidth;
                        triedspaces++;
                        continue;
                    }
                    if (multicol && !triedrecol && fraghadprimary) {
                        dx -= (dirforward ? 1 : -1) * triedspaces * font.spacewidth;
                        triedspaces = 0;
                        col = null;
                        triedrecol = true;
                        continue;
                    }
                    if (dirforward) {
                        x2 = x + dx - font.spacewidth;
                    }
                    else {
                        x1 = x + dx + font.spacewidth;
                    }
                    break;
                }
                else {
                    if (lastcol && (col[0] != lastcol[0] || col[1] != lastcol[1] || col[2] != lastcol[2])) {
                        addfrag(dirforward);
                    }
                    var spaces = "";
                    for (var a = 0; a < triedspaces; a++) {
                        spaces += " ";
                    }
                    if (dirforward) {
                        fragtext += spaces + chr.chr;
                    }
                    else {
                        fragtext = chr.chr + spaces + fragtext;
                    }
                    if (!chr.basechar.secondary) {
                        fraghadprimary = true;
                    }
                    triedspaces = 0;
                    triedrecol = false;
                    dx += (dirforward ? 1 : -1) * chr.basechar.width;
                    fragenddx = dx;
                    lastcol = col;
                }
            }
            if (lastcol && fraghadprimary) {
                addfrag(dirforward);
            }
        }
        fragments.forEach((f, i) => f.index = i);
        return {
            debugArea: { x: x1, y: y - 9, w: x2 - x1, h: 10 },
            text: fragments.map(f => f.text).join(""),
            fragments
        };
    }
    OCR.readLine = readLine;
    /**
     * Reads a line of text that uses a smallcaps font, these fonts can have duplicate chars that only have a different amount of
     * empty space after the char before the next char starts.
     * The coordinates should be near the end of the string, or a rectangle with high 1 containing all points where the string can end.
     */
    function readSmallCapsBackwards(buffer, font, cols, x, y, w = -1, h = -1) {
        if (w == -1) {
            w = font.width + font.spacewidth;
            x -= Math.ceil(w / 2);
        }
        if (h == -1) {
            h = 7;
            y -= 1;
        }
        var matchedchar = null;
        var sorted = (cols.length == 1 ? [{ col: cols[0], score: 1 }] : getChatColorMono(buffer, new Rect(x, y - font.basey, w, h), cols));
        //loop until we have a match (max 2 cols)
        for (var a = 0; a < 2 && a < sorted.length && matchedchar == null; a++) {
            for (var cx = x + w - 1; cx >= x; cx--) {
                var best = 1000; //TODO finetune score constants
                var bestchar = null;
                for (var cy = y; cy < y + h; cy++) {
                    var chr = readChar(buffer, font, sorted[a].col, cx, cy, true, false);
                    if (chr != null && chr.sizescore < best) {
                        best = chr.sizescore;
                        bestchar = chr;
                    }
                }
                if (bestchar) {
                    matchedchar = bestchar;
                    break;
                }
            }
        }
        if (matchedchar == null) {
            return { text: "", debugArea: { x, y, w, h } };
        }
        return readLine(buffer, font, cols, matchedchar.x, matchedchar.y, false, true);
    }
    OCR.readSmallCapsBackwards = readSmallCapsBackwards;
    /**
     * Reads a single character at the exact given location
     * @param x exact x location of the start of the character domain (includes part of the spacing between characters)
     * @param y exact y location of the baseline pixel of the character
     * @param backwards read in backwards direction, the x location should be the first pixel after the character domain in that case
     */
    function readChar(buffer, font, col, x, y, backwards, allowSecondary) {
        const DETECTION_THRESHOLD = 400;
        y -= font.basey;
        const shiftx = 0;
        const shifty = font.basey;
        const shadow = font.shadow;
        //===== make sure the full domain is inside the bitmap/buffer ======
        if (y < 0 || y + font.height >= buffer.height) {
            return null;
        }
        if (!backwards) {
            if (x < 0 || x + font.width > buffer.width) {
                return null;
            }
        }
        else {
            if (x - font.width < 0 || x > buffer.width) {
                return null;
            }
        }
        //====== start reading the char ======
        const candidate_scores = [];
        charloop: for (const chrobj of font.chars) {
            if (chrobj.secondary && !allowSecondary)
                continue;
            let score = 0;
            const chrx = (backwards ? x - chrobj.width : x);
            if (shadow) {
                for (let a = 0; a < chrobj.pixels.length; a += 4) {
                    const i = (chrx + chrobj.pixels[a]) * 4 + (y + chrobj.pixels[a + 1]) * buffer.width * 4;
                    const lum = chrobj.pixels[a + 3] / 255;
                    score += canblend(buffer.data[i], buffer.data[i + 1], buffer.data[i + 2], col[0] * lum, col[1] * lum, col[2] * lum, chrobj.pixels[a + 2] / 255);
                    if (score > DETECTION_THRESHOLD)
                        continue charloop; // Early exit if score has surpassed the threshold already
                }
            }
            else {
                for (let a = 0; a < chrobj.pixels.length; a += 3) {
                    const i = (chrx + chrobj.pixels[a]) * 4 + (y + chrobj.pixels[a + 1]) * buffer.width * 4;
                    score += canblend(buffer.data[i], buffer.data[i + 1], buffer.data[i + 2], col[0], col[1], col[2], chrobj.pixels[a + 2] / 255);
                    if (score > DETECTION_THRESHOLD)
                        continue charloop; // Early exit if score has surpassed the threshold already
                }
            }
            candidate_scores.push({ score: score, sizescore: score - chrobj.bonus, chr: chrobj });
        }
        const winchr = FakeLodash.minBy(candidate_scores, s => s.sizescore);
        if (!winchr || winchr.score > DETECTION_THRESHOLD) {
            return null;
        }
        return { chr: winchr.chr.chr, basechar: winchr.chr, x: x + shiftx, y: y + shifty, score: winchr.score, sizescore: winchr.sizescore };
    }
    OCR.readChar = readChar;
    function loadFontImage(img, meta) {
        var bg = null;
        var pxheight = img.height - 1;
        if (meta.unblendmode == "removebg") {
            pxheight /= 2;
        }
        var inimg = img.clone({ x: 0, y: 0, width: img.width, height: pxheight });
        var outimg;
        if (meta.unblendmode == "removebg") {
            bg = img.clone({ x: 0, y: pxheight + 1, width: img.width, height: pxheight });
            outimg = unblendKnownBg(inimg, bg, meta.shadow, meta.color[0], meta.color[1], meta.color[2]);
        }
        else if (meta.unblendmode == "raw") {
            outimg = unblendTrans(inimg, meta.shadow, meta.color[0], meta.color[1], meta.color[2]);
        }
        else if (meta.unblendmode == "blackbg") {
            outimg = unblendBlackBackground(inimg, meta.color[0], meta.color[1], meta.color[2]);
        }
        else {
            throw new Error("no unblend mode");
        }
        var unblended = new ImageData(img.width, pxheight + 1);
        outimg.copyTo(unblended, 0, 0, outimg.width, outimg.height, 0, 0);
        img.copyTo(unblended, 0, pxheight, img.width, 1, 0, pxheight);
        return generateFont(unblended, meta.chars, meta.seconds, meta.bonus || {}, meta.basey, meta.spacewidth, meta.treshold, meta.shadow);
    }
    OCR.loadFontImage = loadFontImage;
    /**
     * Generates a font json description to use in reader functions
     * @param unblended A source image with all characters lined up. The image should be unblended into components using the unblend functions
     * The lowest pixel line of this image is used to mark the location and size of the charecters if the red component is 255 it means there is a character on that pixel column
     * @param chars A string containing all the characters of the image in the same order
     * @param seconds A string with characters that are considered unlikely and should only be detected if no other character is possible.
     * For example the period (.) character matches positive inside many other characters and should be marked as secondary
     * @param bonusses An object that contains bonus scores for certain difficult characters to make the more likely to be red.
     * @param basey The y position of the baseline pixel of the font
     * @param spacewidth the number of pixels a space takes
     * @param treshold minimal color match proportion (0-1) before a pixel is used for the font
     * @param shadow whether this font also uses the black shadow some fonts have. The "unblended" image should be unblended correspondingly
     * @returns a javascript object describing the font which is used as input for the different read functions
     */
    function generateFont(unblended, chars, seconds, bonusses, basey, spacewidth, treshold, shadow) {
        //settings vars
        treshold *= 255;
        //initial vars
        var miny = unblended.height - 1;
        var maxy = 0;
        var font = { chars: [], width: 0, spacewidth: spacewidth, shadow: shadow, height: 0, basey: 0 };
        var ds = false;
        var chardata = [];
        //index all chars
        for (var dx = 0; dx < unblended.width; dx++) {
            var i = 4 * dx + 4 * unblended.width * (unblended.height - 1);
            if (unblended.data[i] == 255 && unblended.data[i + 3] == 255) {
                if (ds === false) {
                    ds = dx;
                }
            }
            else {
                if (ds !== false) {
                    //char found, start detection
                    var de = dx;
                    var char = chars[chardata.length];
                    var chr = {
                        ds: ds,
                        de: de,
                        width: de - ds,
                        chr: char,
                        bonus: (bonusses && bonusses[char]) || 0,
                        secondary: seconds.indexOf(chars[chardata.length]) != -1,
                        pixels: []
                    };
                    chardata.push(chr);
                    font.width = Math.max(font.width, chr.width);
                    for (x = 0; x < de - ds; x++) {
                        for (y = 0; y < unblended.height - 1; y++) {
                            var i = (x + ds) * 4 + y * unblended.width * 4;
                            if (unblended.data[i] >= treshold) {
                                miny = Math.min(miny, y);
                                maxy = Math.max(maxy, y);
                            }
                        }
                    }
                    ds = false;
                }
            }
        }
        font.height = maxy + 1 - miny;
        font.basey = basey - miny;
        //detect all pixels
        for (var a in chardata) {
            var chr = chardata[a];
            for (var x = 0; x < chr.width; x++) {
                for (var y = 0; y < maxy + 1 - miny; y++) {
                    var i = (x + chr.ds) * 4 + (y + miny) * unblended.width * 4;
                    if (unblended.data[i] >= treshold) {
                        chr.pixels.push(x, y);
                        chr.pixels.push(unblended.data[i]);
                        if (shadow) {
                            chr.pixels.push(unblended.data[i + 1]);
                        }
                        chr.bonus += 5;
                    }
                }
            }
            //prevent js from doing the thing with unnecessary output precision
            chr.bonus = +chr.bonus.toFixed(3);
            font.chars.push({ width: chr.width, bonus: chr.bonus, chr: chr.chr, pixels: chr.pixels, secondary: chr.secondary });
        }
        return font;
    }
    OCR.generateFont = generateFont;
})(OCR || (OCR = {}));
